module.exports = __webpack_public_path__ + "img/favicon.c0133e6.png";